<template>
	<div id="home">
		<!-- New administrative requests  -->
		<v-row class="ma-0 mb-3">
			<v-col lg="12" cols="12"  class="text-h6 pb-0">
				New Staff Requests
			</v-col>
			<v-col lg="2" sm="4">
				<v-btn
					class="text-capitalize text-center"
					color="secondary px-6"
					width="100%"
					height="80px"
					:loading="loading"
					:to="{ name:'day-off-requests' }"
				>
					<div class="d-flex flex-column">
						<span class="btn-num">
							{{ leaveRequests }}
						</span>

						<span>
							Leave requests
						</span>
					</div>
				</v-btn>
			</v-col>
			<v-col lg="2" sm="6">
				<v-btn
					class="text-capitalize text-center"
					color="secondary"
					width="100%"
					height="80px"
					:loading="loading"
					:to="{ name:'day-off-requests' }"
				>	
					<div class="d-flex flex-column">
						<span class="btn-num">{{ administrativeRequests }}</span>
						<span>Administrative day</span>
					</div>
				</v-btn>
			</v-col>
		</v-row>

		<!-- Modification requests -->
		<v-row class="ma-0">
			<v-col lg="12" cols="12" class="text-h6 pb-0">
				New Entities Requests
			</v-col>
			<v-col lg="2">
				<v-btn
					class="text-capitalize text-center"
					color="secondary"
					width="100%"
					height="80px"
					:loading="loading"
					:to="{ name:'modification-requests' }"
				>
					<div class="d-flex flex-column">
						<span class="btn-num">{{ entityModifications }}</span>
						<span>Modification</span>
					</div>
				</v-btn>
			</v-col>
			<v-col lg="2">
				<v-btn
					class="text-capitalize text-center"
					color="secondary"
					width="100%"
					height="80px"
					:loading="loading"
					:to="{ name:'modification-requests' }"
				>
					<div class="d-flex flex-column">
						<span class="btn-num">{{ entityCreations }}</span>
						<span>addition</span>
					</div>
				</v-btn>
			</v-col>
			<v-col lg="2">
				<v-btn
					class="text-capitalize text-center"
					color="red lighten-1 white--text"
					width="100%"
					height="80px"
					:loading="loading"
					:to="{ name:'modification-requests' }"
				>
					<div class="d-flex flex-column">
						<span class="btn-num">{{ entityDeletions }}</span>
						<span>deletion</span>
					</div>
				</v-btn>
			</v-col>
		</v-row>

		<!-- Office visits yesterday -->
		<v-row class="ma-0 mt-3">
			<v-col lg="12" cols="12" class="text-h6 pb-0">
				Yesterday visits / Total visits number
			</v-col>
			<v-col lg="2" sm="4" class="py-0">
				<span class="fs-m">
					{{visitsNumber}} / {{totalVisitsNumber}}
				</span>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
	export default {
		name: 'Home',

		data(){
			return {
				visitsNumber: null,
				totalVisitsNumber: null,
				leaveRequests: 0,
				administrativeRequests: 0,
				entityModifications: 0,
				entityCreations: 0,
				entityDeletions: 0,

				loading: false,
			}
		},
		
		computed:{
			...mapState({
				medicalreps: state => state.medicalreps.medicalreps,
				employeeId: state => state.auth.userData.id
			})
		},

		methods:{
			moment
		},

		mounted(){
			this.loading = true;
			Promise.all([
				window.axios.get('/home').then(response => {
					this.leaveRequests = response.data.leaveRequests;
					this.administrativeRequests = response.data.administrativeRequests;
					this.entityModifications = response.data.entityModifications;
					this.entityCreations = response.data.entityCreations;
					this.entityDeletions = response.data.entityDeletions;
					this.visitsNumber = response.data.visitsYesterday;
					this.totalVisitsNumber = response.data.visitTargets;
				})
			])
			.finally(() => {
				this.loading = false;
			})
		},

		metaInfo: {
			title: 'Octopharma'
		},
	}
</script>
<style scoped>
.btn-num {
	font-size: 30px;
	font-weight: bolder;
}
.fs-m {
	font-size: 23px;
	font-weight: bolder;
}
</style>
